import { StaticImageData } from 'next/image';

import animalsCategoryIcon from '@/public/public/images/animals.png';
import educationCategoryIcon from '@/public/public/images/book.png';
import kidsAndFamilyCategoryIcon from '@/public/public/images/children.png';
import communityCategoryIcon from '@/public/public/images/community.png';
import environmentCategoryIcon from '@/public/public/images/eco.png';
import elderlyCategoryIcon from '@/public/public/images/elderly.png';
import healthCategoryIcon from '@/public/public/images/health.png';
import humanitarianHelpCategoryIcon from '@/public/public/images/help.png';
import damageCategoryIcon from '@/public/public/images/mountains.png';
import cultureCategoryIcon from '@/public/public/images/music.png';
import { useCallback, useMemo } from 'react';
import { useGetCategories } from '@/src/api/client';
import { SelectOption } from '@/app/components/Select/Select';
import { useTranslation } from 'react-i18next';
import myChoiceCategoryIcon from '@/public/public/images/story.png';

export const categorySlugToIconMap: Record<string, StaticImageData> = {
  'deti-rodina': kidsAndFamilyCategoryIcon,
  'humanitarni-pomoc': humanitarianHelpCategoryIcon,
  komunita: communityCategoryIcon,
  kultura: cultureCategoryIcon,
  priroda: environmentCategoryIcon,
  seniori: elderlyCategoryIcon,
  'skody-na-majetku': damageCategoryIcon,
  vzdelavani: educationCategoryIcon,
  zdravi: healthCategoryIcon,
  zvirata: animalsCategoryIcon,
};

export const useCategoriesOptions = () => {
  const { data, isLoading, error } = useGetCategories();
  const categories = data?.categories || [];
  const { t } = useTranslation();

  const categoryOptions = useMemo(() => {
    const categoriesFromApi = categories.reduce(
      (acc, category) => {
        if (!category.id || !category.slug || !category.name) {
          return acc;
        }

        return [
          ...acc,
          {
            value: category.id,
            label: category.name,
            image: categorySlugToIconMap[category.slug],
          },
        ];
      },
      [] as (SelectOption<string> & { image: StaticImageData })[],
    );

    return [
      { value: undefined, label: t('enums.donationFields.myChoice'), image: myChoiceCategoryIcon },
      ...categoriesFromApi,
    ];
  }, [t, data, isLoading]);

  const getCategoryImage = useCallback(
    (selectedCategory?: string | null) => {
      const selectedOption = categoryOptions.find((option) => option.value === selectedCategory);

      if (!selectedOption) {
        return null;
      }

      return selectedOption.image;
    },
    [categoryOptions],
  );

  const getCategoryLabel = useCallback(
    (selectedCategory?: string | null) => {
      const selectedOption = categoryOptions.find((option) => option.value === selectedCategory);

      if (!selectedOption) {
        return null;
      }

      return selectedOption.label;
    },
    [categoryOptions],
  );

  return { getCategoryImage, getCategoryLabel, categoryOptions, isLoading, error };
};
